import AttachmentPreviewWellView from './schema/AttachmentPreviewWellView';
import BusStopState from './schema/BusStopState';
import ConversationItem from './schema/ConversationItem';
import ListViewStore from './schema/ListViewStore';
import TableView from './schema/TableView';
import TableViewConversationRelation from './schema/TableViewConversationRelation';
import RowInfoForVLV from './schema/RowInfoForVLV';
import TableViewItemRelation from './schema/TableViewItemRelation';
import { ObservableMap } from 'mobx';
import { AttachmentFullViewState } from 'owa-attachment-well-data';
import { createStore } from 'satcheljs';
import { ClientItem } from 'owa-mail-store';
export { ObservableMap };

const listViewDefaultStore: ListViewStore = {
    conversationItems: new ObservableMap<string, ConversationItem>({}),
    itemContextMenuState: null,
    selectedTableViewId: null,
    tableViewConversationRelations: new ObservableMap<string, TableViewConversationRelation>({}),
    tableViewItemRelations: new ObservableMap<string, TableViewItemRelation>({}),
    tableViews: new ObservableMap<string, TableView>({}),
    attachmentViewStates: new ObservableMap<string, AttachmentFullViewState>({}),
    expandedConversationViewState: {
        expandedRowKey: null,
        focusedNodeId: null,
        selectedNodeIds: [],
        allNodeIds: [],
        shouldBeExpanded: false,
        busStopStateMap: new ObservableMap<string, BusStopState>({}),
    },
    rowAttachmentPreviewWellViews: new ObservableMap<string, AttachmentPreviewWellView>({}),
    focusedOtherDropViewState: null,
    couponPeekPreviews: new ObservableMap<string, string[]>({}),
    rowInfoForVLV: new ObservableMap<string, RowInfoForVLV>({}),
    meetingMessageItems: new ObservableMap<string, ClientItem>({}),
    offsetHeight: 0,
    scrollTop: 0,
    inboxPausedDateTime: null,
    inboxPausedLength: null,
};

export let getStore = createStore<ListViewStore>('listview', listViewDefaultStore);
const listViewStore = getStore();

export default listViewStore;
